import { Card } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import * as Api from 'api';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';

interface DataType {
  key: number;
  action: string;
  reason: string;
  time: string;
}

const columns: ColumnsType<DataType> = [
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
  },
  {
    title: 'Reason',
    dataIndex: 'reason',
    key: 'reason',
  },
  {
    title: 'Time',
    dataIndex: 'time',
    key: 'time',
  },
];

const SmartFeederActivity = ({ feeder }) => {
  const [data, setData] = useState<DataType[]>([]);
  useEffect(() => {
    if (feeder) {
      loadActivty(feeder);
    }
  }, [feeder]);

  const loadActivty = (feederIMEI) => {
    const param = {
      IMEI: feederIMEI,
    };
    Api.SMARTFEEDER_COMMNAD_HISTORY(param).then((res: any) => {
      const result = JSON.parse(res.text);
      const activities = result.map((activity: any, index: number) => (
        {
          key: index,
          action: activity.command.charAt(0).toUpperCase() + activity.command.slice(1),
          reason: activity.info.charAt(0).toUpperCase() + activity.info.slice(1),
          time: dayjs.unix(activity.created_at).format('HH:mm MM/DD/YYYY'),
        }
      ));
      setData(activities);
    });
  };
  return (
    <Card title="Recent Activity">
      <Table columns={columns} dataSource={data} />
    </Card>
  );
};

export default SmartFeederActivity;
